// extracted by mini-css-extract-plugin
module.exports = {"noscriptWrapper":"global--noscript-wrapper--1wiC_"};